import { Flex } from "antd";
import React, { useEffect, useState } from "react";
import UserList from "../../../components/AgencyComp/UserComp/UserList";
import { useDispatch, useSelector } from "react-redux";
import { fetchAgencyUsers, fetchAreaCodes } from "../../../store/agencySlice";
import { fetchBankDashboard } from "../../../store/portfolioSlice";

const AgencyUserPage = () => {
  const { user_list, user_loading, area_codes_list, area_codes_loading } =
    useSelector((state) => state?.agency);
      const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const dispatch = useDispatch();

  const { bankDashboard, bankDashboard_loading } = useSelector(
    (state) => state?.portfolio
  );
  
  const { user } = useSelector((state) => state?.auth);

  useEffect(() => {
    dispatch(fetchAgencyUsers({ page: 1, page_size: 10 }));
    if (user?.is_agency) {
      dispatch(fetchBankDashboard());
      dispatch(fetchAreaCodes());
    }
  }, [dispatch, user]);

  const handlePagination = (page, page_size) => {
    dispatch(fetchAgencyUsers({ page, page_size }));
  };

  return (
    <Flex
      vertical
      className="agencyUserPageContainer"
      style={{ width: "100%", height: "100%" }}
    >
      <UserList
        data={user_loading ? Array(4).fill({}) : user_list}
        loading={user_loading}
        bankData={bankDashboard}
        areaCodes={area_codes_list}
        onPaginationChange={handlePagination}
        currentPage={currentPage}
        pageSize={pageSize}
        setCurrentPage={setCurrentPage}
        setPageSize={setPageSize}
        isAddUser={false}
      />
    </Flex>
  );
};
export default AgencyUserPage;
